'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationGuard = exports.touchField = void 0;
var tslib_1 = require("tslib");
var vue_class_component_1 = require("vue-class-component");
/**
 * Calls the vuelidate $touch method on the field and fields
 * children.
 * @param field
 */
var touchField = function (field) {
    if (!field) {
        return;
    }
    if (field.$touch) {
        field.$touch();
    }
    if (field.$each && field.$each.$iter) {
        for (var _i = 0, _a = Array.from(field.$each.$iter); _i < _a.length; _i++) {
            var innerField = _a[_i];
            exports.touchField(innerField);
        }
    }
};
exports.touchField = touchField;
/**
 * Guards a components submit or similar functionality from invalid forms.
 * Touches all inputs in the form to ensure new errors are shown.
 * If the inputs have ref (and is the same value as the name)
 * it will scroll to the first wrong input
 */
var ValidationGuard = function () {
    return vue_class_component_1.createDecorator(function (options, key) {
        if (!options.methods) {
            options.methods = {};
        }
        if (!options.validations) {
            return;
        }
        var methodToGuard = options.methods[key];
        if (methodToGuard) {
            options.methods[key] = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                if (this.$v.$invalid) {
                    var firstInvalidField = null;
                    for (var _a = 0, _b = Object.keys(this.$v); _a < _b.length; _a++) {
                        var field = _b[_a];
                        if (field.startsWith('$') || field.startsWith('_')) {
                            continue;
                        }
                        if (this.$v[field].$invalid &&
                            firstInvalidField === null) {
                            firstInvalidField = this.$refs[field];
                        }
                        exports.touchField(this.$v[field]);
                    }
                    return;
                }
                methodToGuard.call.apply(methodToGuard, tslib_1.__spreadArray([this], args));
            };
        }
    });
};
exports.ValidationGuard = ValidationGuard;
